<script setup>
import {computed, onMounted, ref, useSlots, watch} from "vue";
import {Modal} from "bootstrap";
import {ElMessageBox} from 'element-plus'

const slots = useSlots()
let componentKey = ref(0);
let loadComponent = ref(false);
const dialogVisible = ref(false)

const emit = defineEmits(["close", "save", "update:title"]);
const props = defineProps({
    target: {
        type: String,
        required: true,
    },
    component: {
        type: Object,
    },
    componentProps: {
        type: Object,
    },
    title: {
        type: String,
    },
    size: {
        validator: function (value) {
            // The value must match one of these strings
            return ['xl', 'lg', 'sm'].indexOf(value) !== -1
        },
    },
    closeable: {
        type: Boolean,
        default: false,
    },
});

watch(
    () => props.closeable,
    (val) => {
        if (val) {
            close('create')
        }
    }
)

const sizeClass = computed(() => {
    return props.size ? `modal-${props.size}` : '';
})

const hasSlot = (name = 'default') => {
    return Object.keys(slots).includes(name);
}

const close = (context) => {
    if (context != 'create') {
        ElMessageBox.confirm('Are you sure to close this dialog?')
            .then(() => {
                Modal.getInstance(document.getElementById(props.target)).hide();
                done()
            })
            .catch(() => {
                // catch error
            })

        return true
    }

    Modal.getInstance(document.getElementById(props.target)).hide();
}

onMounted(() => {
    const myModalEl = document.getElementById(props.target)
    myModalEl.addEventListener('show.bs.modal', event => {
        loadComponent.value = true;
        componentKey.value += 1;
    })

    myModalEl.addEventListener('hidden.bs.modal', event => {
        loadComponent.value = false;
        componentKey.value += 1;
    })
})
defineOptions({inheritAttrs: false});
</script>

<template>
    <Teleport to="body">
        <div
            :id="target"
            ref="closeModal"
            aria-hidden="true"
            aria-labelledby="exampleModalLabel"
            class="modal fade customModal"
            tabindex="-1"
        >
            <div
                :class="sizeClass"
                class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
            >

                <div class="modal-content">
                    <div class="modal-header">
                        <h1
                            id="exampleModalLabel"
                            class="modal-title fs-5"
                        >
                            {{ title }}
                        </h1>
                        <button
                            aria-label="Close"
                            class="btn-close"
                            type="button"
                            @click="close"
                        >
                            <svg
                                fill="none"
                                height="24"
                                viewBox="0 0 24 24"
                                width="24"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M12 22.75C17.93 22.75 22.75 17.93 22.75 12C22.75 6.07 17.93 1.25 12 1.25C6.07 1.25 1.25 6.07 1.25 12C1.25 17.93 6.07 22.75 12 22.75ZM12 2.75C17.1 2.75 21.25 6.9 21.25 12C21.25 17.1 17.1 21.25 12 21.25C6.9 21.25 2.75 17.1 2.75 12C2.75 6.9 6.9 2.75 12 2.75Z"
                                    fill="#5E45FF"
                                ></path>
                                <path
                                    d="M14.8306 15.5794C15.0206 15.5794 15.2106 15.5094 15.3606 15.3594C15.6506 15.0694 15.6506 14.5894 15.3606 14.2994L9.70062 8.63938C9.41062 8.34938 8.93063 8.34938 8.64063 8.63938C8.35063 8.92937 8.35063 9.40937 8.64063 9.69937L14.3006 15.3594C14.4406 15.5094 14.6406 15.5794 14.8306 15.5794Z"
                                    fill="#5E45FF"
                                ></path>
                                <path
                                    d="M9.17063 15.5794C9.36063 15.5794 9.55062 15.5094 9.70062 15.3594L15.3606 9.69937C15.6506 9.40937 15.6506 8.92937 15.3606 8.63938C15.0706 8.34938 14.5906 8.34938 14.3006 8.63938L8.64063 14.2994C8.35063 14.5894 8.35063 15.0694 8.64063 15.3594C8.79063 15.5094 8.98063 15.5794 9.17063 15.5794Z"
                                    fill="#5E45FF"
                                ></path>
                            </svg>
                        </button>
                        <slot name="header"></slot>
                    </div>

                    <div class="modal-body">
                        <component
                            :is="component"
                            v-if="loadComponent"
                            :key="componentKey"
                            v-bind="componentProps"
                            @close="close"
                            @create="close('create')"
                            @update:title="(val) => emit('update:title', val)"
                        />

                        <!-- <component v-if="edit" :is="component" :edit="edit"  @create="close" :key="componentKey" />
                            <component v-if="create" :is="component" :edit="edit"  @create="close" :key="componentKey" /> -->

                        <!--                            <slot v-else>Modal Contents Here...</slot>-->
                    </div>

                    <div
                        v-if="hasSlot('footer')"
                        class="modal-footer"
                    >
                        <slot name="footer">
                            <button
                                class="btn btn-secondary"
                                type="button"
                                @click="$emit('close')"
                            >Close
                            </button>
                            <button
                                class="btn btn-primary"
                                type="button"
                                @click="$emit('save')"
                            >Save changes
                            </button>
                            <button
                                class="btn btn-primary"
                                type="button"
                                @click="close"
                            >Close
                            </button>
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </Teleport>
</template>

<style scoped>
.customModal .modal-header {
    border-bottom: 0;
}
</style>
